var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveServiceRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41637 6.41793L3.4997 3.50126M2.91637 4.37626L4.3747 2.91793L2.6247 2.04293L2.04137 2.62626L2.91637 4.37626ZM11.6518 5.23668C11.9318 4.95686 12.1245 4.60166 12.2063 4.21431C12.2882 3.82696 12.2556 3.42418 12.1126 3.05501L11.2831 3.88451H10.1164V2.71784L10.9459 1.88834C10.5767 1.74504 10.1738 1.71221 9.78631 1.79385C9.39878 1.87549 9.04337 2.06808 8.76336 2.34815C8.48335 2.62822 8.29084 2.98368 8.20929 3.37123C8.12773 3.75877 8.16065 4.16167 8.30403 4.53084L4.52987 8.30559C4.1607 8.16221 3.7578 8.12929 3.37025 8.21085C2.98271 8.2924 2.62724 8.48491 2.34717 8.76492C2.0671 9.04493 1.87452 9.40034 1.79288 9.78787C1.71124 10.1754 1.74407 10.5783 1.88737 10.9475L2.71628 10.118H3.88295V11.2847L3.05345 12.1142C3.42256 12.2575 3.82537 12.2904 4.21283 12.2088C4.60029 12.1273 4.95568 11.9348 5.23572 11.6549C5.51576 11.375 5.70836 11.0197 5.79007 10.6323C5.87179 10.2448 5.83909 9.84201 5.69595 9.47284L9.47128 5.69751C9.8403 5.84024 10.2428 5.87267 10.63 5.79086C11.0171 5.70904 11.3721 5.51651 11.6518 5.23668Z",
    stroke: "#8B8B8B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88086 8.45956L10.1499 11.7286C10.223 11.8018 10.3099 11.86 10.4055 11.8997C10.5012 11.9393 10.6037 11.9597 10.7072 11.9597C10.8108 11.9597 10.9133 11.9393 11.0089 11.8997C11.1046 11.86 11.1915 11.8018 11.2646 11.7286L11.7266 11.2666C11.7999 11.1934 11.858 11.1065 11.8977 11.0109C11.9374 10.9153 11.9578 10.8127 11.9578 10.7092C11.9578 10.6056 11.9374 10.5031 11.8977 10.4075C11.858 10.3118 11.7999 10.225 11.7266 10.1518L8.45761 6.88281",
    stroke: "#8B8B8B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveServiceRequest);
export default __webpack_public_path__ + "static/media/InActiveServiceRequest.132f1ef591a58ade34f2e8bb1fbb9240.svg";
export { ForwardRef as ReactComponent };